import React from "react";
import download from "downloadjs";
import { Space, Typography } from "antd";
import { Trans } from "react-i18next";
import { GRAY_500 } from "../constant/colors";
import { sizes, fontWeights } from "../constant/styles";
import { ReactComponent as WarningIcon } from "../assets/svg/warning-icon-popup.svg";
import { FILE_TYPES } from "../constant/export";

const { Text } = Typography;

export const ExportModalContent = ({ count, fileType, t }) => {
  const fileTypeText = fileType === FILE_TYPES.XLSX ? t("export.xlsx_option") : t("export.csv_option");

  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      <div id="export-modal-description">
        <Text style={{ fontSize: sizes.medium, color: GRAY_500 }}>
          <Trans
            i18nKey="export.modal_summary"
            values={{ count: count?.toLocaleString(), fileType: fileTypeText }}
            components={{
              strong: <Text style={{ color: GRAY_500, fontWeight: fontWeights.bold }} strong />
            }}
          />
        </Text>
      </div>
      <div>
        <Text style={{ fontSize: sizes.small, color: GRAY_500 }}>
          <Trans
            i18nKey="export.modal_phi_warning_text"
            values={{ subtitle: t("export.subtitle") }}
            components={{ strong: <Text style={{ color: GRAY_500, fontWeight: fontWeights.bold }} strong /> }}
          />
        </Text>
      </div>
    </Space>
  );
};

export const showExportConfirmModal = (modal, { recordCount, fileType, t, onConfirm }) => {
  modal.confirm({
    centered: true,
    okText: t("export.modal_confirm_button"),
    cancelText: t("cancel"),
    icon: <WarningIcon />,
    title: t("export.modal_title"),
    content: <ExportModalContent count={recordCount} fileType={fileType} t={t} />,
    onOk: () => {
      if (onConfirm) {
        onConfirm(fileType);
      }
    }
  });
};

export const downloadBlob = (blob, filename, mimeType = "text/csv") => {
  download(blob, filename, mimeType);
};

export const handleExportResponse = (response, onSuccess = null) => {
  const { fileName, fileContent, fileType } = response.data;

  // Determine MIME type and create blob based on file type
  let blob;
  let mimeType;

  if (fileType === FILE_TYPES.XLSX) {
    const binaryString = window.atob(fileContent);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    blob = new Blob([bytes], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    mimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  } else {
    blob = new Blob([fileContent], { type: "text/csv" });
    mimeType = "text/csv";
  }

  downloadBlob(blob, fileName, mimeType);

  // Call success callback if provided
  if (onSuccess) {
    onSuccess();
  }
};
